import React, {useEffect, useState} from 'react';
import {CommonContext} from "./index";
import AuthService from "../API/AuthService";

function ContextCommon({children}) {

    const [isAuth, setIsAuth] = useState(false);
    const [isSensorInMaintenance, setIsSensorInMaintenance]  = useState(false);

    useEffect(() => {
        AuthService.login().then(() => setIsAuth(true));
    }, []);

    return (
        <CommonContext.Provider value={{
            isAuth,
            isSensorInMaintenance,
            setIsSensorInMaintenance
        }}>
            {children}
        </CommonContext.Provider>
    );
}

export default ContextCommon;